export const postActionTypes = {
  CREATE_POST: 'CREATE_POST',
  GET_ONE_POST: 'GET_POST',
  DELETE_POST: 'DELETE_POST',
  EDIT_POST: 'EDIT_POST'
}

export const feedActionTypes = {
  GET_FEED: 'GET_FEED'
}

export const userActionTypes = {
  GET_USER: 'GET_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
  SET_CURRENT_USER_TYPE: 'SET_CURRENT_USER_TYPE',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_TOKEN: 'SET_CURRENT_USER_TOKEN'
}

export const alertActionTypes = {
  SET_ALERT_MESSAGE: 'SET_ALERT_MESSAGE'
}

export const dashActionTypes = {
  SET_LEFT_DASH_OPEN: 'SET_LEFT_DASH_OPEN'
}

export const appActionTypes = {
  SET_BIG_SCREEN: 'SET_BIG_SCREEN'
}
